import { IncomeDetails } from './income_details';
import { status } from '../../../core/user';
import * as firebase from 'firebase';
import { ThrowStmt } from '@angular/compiler';

export class Investor {
  iid: string;
  creatorId: string;
  RAName: string;
  status: status;
  createdAt: firebase.firestore.FieldValue;
  updatedAt: firebase.firestore.FieldValue;
  name: string;
  searchName: string;
  email: string;
  phone: string;
  DOB: Date;
  spouse_name: string;
  profession: string;
  tax_slab: number;
  risk_category: string;
  // age: number;
  retirement_age: number;
  life_expectancy: number;
  no_of_dependents: number;
  inflation_rate: number;
  inflation_type: string;
  income_source: string;
  total_income: number;
  total_expenditure: number;
  total_main_income: number;
  total_main_expenditure: number;
  total_spouse_income: number;
  total_spouse_expenditure: number;

  total_salary_professional_income: number;
  emergency_funds_multiplier: number;
  surplus_amount: number;
  surplus_amount_to_invest: number;

  total_financial_assets_value: number;
  total_liquid_assets_value: number;
  total_liquid_financial_assets_value: number;
  total_other_assets_value: number;
  total_tangile_assets_value: number;
  total_personal_assets_value: number;
  total_retirement_assets_value: number;
  liquid_financial_weighted_average: number;
  total_marketable_assets_value: number;
  other_assets_weighted_average: number;
  total_liabilities_value: number;
  total_emergency_funds: number;
  total_annual_surplus_amount: number;
  total_investing_SIP_amount: number;
  total_liquid_financial_assets_investing_value: number;
  total_other_assets_investing_value: number;
  total_opening_balance: number;

  total_networth: number;
  total_other_assets_amount_to_invest: number;
  assets_income_score: number;

  incomes = {};
  expenses = {};
  assets = [];
  liabilities = [];
  insurances = {};
  goals = {};

  constructor(data?: any) {
    console.log(data);
    this.iid = (data && data.iid) || '';
    this.creatorId = (data && data.creatorId) || '';
    this.RAName = (data && data.RAName) || '';
    this.status = (data && data.status) || status.new;
    this.createdAt =
      (data && data.createdAt) ||
      firebase.firestore.FieldValue.serverTimestamp();
    this.updatedAt =
      (data && data.updatedAt) ||
      firebase.firestore.FieldValue.serverTimestamp();
    this.name = (data && data.name) || '';
    this.searchName = (data && data.searchName) || this.name.toLocaleLowerCase;
    this.email = (data && data.email) || '';
    this.phone = (data && data.phone) || '';
    this.DOB = (data && data.DOB) || new Date();
    this.spouse_name = (data && data.spouse_name) || '';
    this.profession = (data && data.profession) || '';
    this.tax_slab = (data && data.tax_slab) || 1;
    this.risk_category = (data && data.risk_category) || 'aggressive';
    // this.age = (data && data.age) || 0;
    this.retirement_age = (data && data.retirement_age) || 60;
    this.life_expectancy = (data && data.life_expectancy) || 85;
    this.no_of_dependents = (data && data.no_of_dependents) || 0;
    this.inflation_rate = (data && data.inflation_rate) || 0;
    this.inflation_type = (data && data.inflation_type) || '';
    this.income_source = (data && data.income_source) || '';
    this.total_income = (data && data.total_income) || 0;
    this.total_expenditure = (data && data.total_expenditure) || 0;
    this.total_main_income = (data && data.total_main_income) || 0;
    this.total_main_expenditure = (data && data.total_main_expenditure) || 0;
    this.total_spouse_income = (data && data.total_spouse_income) || 0;
    this.emergency_funds_multiplier =
      (data && data.emergency_funds_multiplier) || 6;
    this.total_spouse_expenditure =
      (data && data.total_spouse_expenditure) || 0;
    this.total_salary_professional_income =
      (data && data.total_salary_professional_income) || 0;
    this.surplus_amount = (data && data.surplus_amount) || 0;
    this.surplus_amount_to_invest =
      (data && data.surplus_amount_to_invest) || 0;

    this.total_financial_assets_value =
      (data && data.total_financial_assets_value) || 0;
    this.total_liquid_assets_value =
      (data && data.total_liquid_assets_value) || 0;
    this.total_liquid_financial_assets_value =
      (data && data.total_liquid_financial_assets_value) || 0;
    this.total_other_assets_value =
      (data && data.total_other_assets_value) || 0;
    this.total_tangile_assets_value =
      (data && data.total_tangile_assets_value) || 0;
    this.total_personal_assets_value =
      (data && data.total_personal_assets_value) || 0;
    this.total_retirement_assets_value =
      (data && data.total_retirement_assets_value) || 0;
    this.liquid_financial_weighted_average =
      (data && data.liquid_financial_weighted_average) || 0;
    this.total_marketable_assets_value =
      (data && data.total_marketable_assets_value) || 0;
    this.other_assets_weighted_average =
      (data && data.other_assets_weighted_average) || 0;

    this.total_liabilities_value = (data && data.total_liabilities_value) || 0;
    this.total_emergency_funds = (data && data.total_emergency_funds) || 0;
    this.total_annual_surplus_amount =
      (data && data.total_annual_surplus_amount) || 0;
    this.total_investing_SIP_amount =
      (data && data.total_investing_SIP_amount) || 0;
    this.total_liquid_financial_assets_investing_value =
      (data && data.total_liquid_financial_assets_investing_value) || 0;
    this.total_other_assets_investing_value =
      (data && data.total_other_assets_investing_value) || 0;
    this.total_opening_balance = (data && data.total_opening_balance) || 0;

    this.total_networth = (data && data.total_networth) || 0;
    this.total_other_assets_amount_to_invest =
      (data && data.total_other_assets_amount_to_invest) || 0;
    this.assets_income_score = (data && data.assets_income_score) || 0;
    if (data) {
      this.insurances = data.insurances;
      this.goals = data.goals;
      this.incomes = data.incomes;
      this.liabilities = data.liabilities;
      this.expenses = data.expenses;
      this.assets = data.assets;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/models/investor.ts